import { handleActions } from 'redux-actions'
import {
  DB_FETCH_REQUEST,
  DB_FETCH_SUCCESS,
  DB_FETCH_FAILURE
} from 'store/actions';

export default handleActions({
  [DB_FETCH_REQUEST]: (state) => {
    return Object.assign({}, state, {isFetching: true});
  },
  [DB_FETCH_SUCCESS]: (state, action) => {
    return Object.assign({}, state, {
      isFetching: false,
      errors: Object.assign({}, action.payload.errors),
      entities: Object.assign({}, state.entities, action.payload.entities),
      result: Object.assign({}, state.result, action.payload.result)
    });
  },
  [DB_FETCH_FAILURE]: (state, action) => {
    return Object.assign({}, state, {
      isFetching: false,
      errors: Object.assign({}, action.payload.errors, {
        server : true
      }),
      result: Object.assign({}, state.result, {
        server: action.payload
      })
    });
  }
},{
  isFetching: false
});



// WEBPACK FOOTER //
// ./src/store/reducers/db.reducer.js